import { render, staticRenderFns } from "./NewProspectsReportChart.vue?vue&type=template&id=9f605a4e&scoped=true&"
import script from "./NewProspectsReportChart.vue?vue&type=script&lang=js&"
export * from "./NewProspectsReportChart.vue?vue&type=script&lang=js&"
import style0 from "./NewProspectsReportChart.vue?vue&type=style&index=0&id=9f605a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f605a4e",
  null
  
)

export default component.exports